import React from 'react';
import {FormattedMessage} from 'react-intl';
import {element, bool, func} from 'prop-types';
import BasicComponents from 'components/forms/Component Sets/BasicFormComponents';
import SegmentSectionWrapper from 'components/common/SegmentSectionWrapper';
import ResourceForm from 'components/forms/ResourceForm';
import BasicModal from 'components/common/BasicModal';
import {makeFormFactory} from 'utils/helpers';

const formConfig = {
  sections: [{
    key: 'basicInfo',
    props: {
      headerKey: 'humanologyHubUsers.modal.visibleColumns.basicInfo.header'
    },
    fields: [{
      type: 'checkbox',
      name: 'basicInfo'
    }]
  }, {
    key: 'demographics',
    props: {
      headerKey: 'humanologyHubUsers.modal.visibleColumns.demographics.header'
    },
    fields: [{
      type: 'checkbox',
      name: 'demographics'
    }]
  }, {
    key: 'socialPlatforms',
    props: {
      headerKey: 'humanologyHubUsers.modal.visibleColumns.socialPlatforms.header'
    },
    fields: [{
      type: 'checkbox',
      name: 'socialPlatforms'
    }]
  }, {
    key: 'recentActivities',
    props: {
      headerKey: 'humanologyHubUsers.modal.visibleColumns.recentActivities.header'
    },
    fields: [{
      type: 'checkbox',
      name: 'recentActivities'
    }]
  },
  {
    key: 'healthAttitude',
    props: {
      headerKey: 'humanologyHubUsers.modal.visibleColumns.healthAttitude.header'
    },
    fields: [{
      type: 'checkbox',
      name: 'healthAttitude'
    }]
  }

]
};

export default class VisibleColumnsModal extends React.Component {
  static propTypes = {
    checkbox: element.isRequired,
    isOpen: bool.isRequired,
    submit: func.isRequired,
    onValueChanged: func.isRequired,
    handleSubmit: func.isRequired,
    handleClose: func.isRequired
  };

  onValueChanged = (resourcePath, fieldPath, value) => {
    this.props.onValueChanged(fieldPath.join('.'), value);
  };

  render() {
    return (
      <BasicModal
        header={<FormattedMessage id='modal.visibleColumns.header' />}
        specialType='visible-columns-modal primary-modal'
        dimmer='inverted'
        modalSize='small'
        actions={[
          {
            label: <FormattedMessage id='modal.visibleColumns.cancel' />,
            action: this.props.handleClose,
            isDisabled: false,
            displayType: 'menu-item'
          },
          {
            label: <FormattedMessage id='modal.visibleColumns.confirm' />,
            action: this.props.handleSubmit,
            isDisabled: false,
            primaryCheck: true,
            displayType: 'button'
          }
        ]}
        open={this.props.isOpen}
        onClose={this.props.handleClose}>
        <ResourceForm
          config={formConfig}
          sectionWrapper={SegmentSectionWrapper}
          components={{checkbox: this.props.checkbox}}
          resource={{visibleColumns: this.props.columns}}
          errors={this.props.errors}
          onValueChanged={this.onValueChanged}
          onValidationError={this.props.onValidationError} />
      </BasicModal>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/common/VisibleColumnsModal.jsx